import { mapState } from 'vuex'
import config from '@/config'
export default {
  data () {
    return {
      projectName: config.projectName
    }
  },
  computed: {
    ...mapState([
      'user',
      'device'
    ]),
    isAgent () {
      return this.user.level === '3' || this.user.level === '4'
    }
  },
  methods: {

    validateForm (form) {
      return new Promise((resolve, reject) => {
        form.validateFields((errors, values) => {
          if (errors) reject(errors)
          else resolve(values)
        })
      })
    },
    isMobile () {
      return this.device === 'mobile'
    },
    isDesktop () {
      return this.device === 'desktop'
    },
    isTablet () {
      return this.device === 'tablet'
    },
    confirm (title, content) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: title,
          content: content,
          onOk () {
            resolve()
          },
          onCancel () {
            reject(new Error('cancel'))
          }
        })
      })
    },
    triggerWindowResizeEvent () {
      const event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      event.eventType = 'message'
      window.dispatchEvent(event)
    },
    getChinaDate (isoString) {
      let date = new Date(isoString)
      return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'),
        [date.getHours(), date.getMinutes()].join(':')
      ].join(`     `).replace(/(?=\b\d\b)/g, '0')
    },
    numberCode (num) { // 传入位数
      return (Math.random() * Math.pow(10, num)).toFixed(0)
    }
  }
}
